import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PrivacyPolicyStatus {
  status: boolean;
}

const licenceStatusSlice = createSlice({
  name: "licenceStatus",
  initialState: true,
  reducers: {
    setLicenceValidity: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

const privacyPolicyStatusSlice = createSlice({
  name: "privacyPolicyStatus",
  initialState: { status: true } as PrivacyPolicyStatus,
  reducers: {
    setPrivacyPolicyStatus: (_state: PrivacyPolicyStatus, action: PayloadAction<PrivacyPolicyStatus>) => action.payload,
  },
});

export const { setLicenceValidity } = licenceStatusSlice.actions;

// `setPrivacyPolicyStatus` is intentionally exported raw (NOT wrapped with `Exact<>`).
// The consumer in actions/licence.ts dispatches a backend response payload
// that includes extra fields (`errorMessage`, `data`) beyond `PrivacyPolicyStatus`.
export const { setPrivacyPolicyStatus } = privacyPolicyStatusSlice.actions;

export const licenceStatus = licenceStatusSlice.reducer;
export const privacyPolicyStatus = privacyPolicyStatusSlice.reducer;
